import css from './index.module.scss';
import EfImg from '@elem/ui/ef-img';
import { useLang } from '@/i18n';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

type ItemType = {
    img: string;
    text: string;
};
export default function Modal2({ type, callback }: any) {
    const { t } = useLang('Oasis');
    const [isPC, setIsPC] = useState(false);
    const [open, setIsOpen] = useState(false);
    const { locale = 'us' } = useRouter();
    // 图片素材
    const imgItems: {
        [key: string]: any;
    } = {
        eu: [
            'https://websiteoss.ecoflow.com/upload/image/1744623239183/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623239403/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623239804/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623240032/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623240406/5.png',
        ],
        nl: [
            'https://websiteoss.ecoflow.com/upload/image/1744623239183/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623239403/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623239804/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623240032/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623240406/5.png',
        ],
        uk: [
            'https://websiteoss.ecoflow.com/upload/image/1744623406017/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623406403/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623406620/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623406841/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623406204/5.png',
        ],
        //已完成de
        de: [
            'https://websiteoss.ecoflow.com/upload/image/1744623558708/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623559389/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623558746/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623559200/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623559001/5.png',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/upload/image/1744623669591/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623670450/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623670066/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623670624/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623669790/5.png',
        ],
        it: [
            'https://websiteoss.ecoflow.com/upload/image/1744623239183/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623239403/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623239804/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623240032/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623240406/5.png',
        ],
        es: [
            'https://websiteoss.ecoflow.com/upload/image/1744623239183/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623239403/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623239804/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623240032/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623240406/5.png',
        ],
    };
    const items: ItemType[] = [
        {
            img: imgItems[locale][0],
            text: t('C_modal2_text1'),
        },
        {
            img: imgItems[locale][1],
            text: t('C_modal2_text2'),
        },
        {
            img: imgItems[locale][2],
            text: t('C_modal2_text3'),
        },
        {
            img: imgItems[locale][3],
            text: t('C_modal2_text4'),
        },
        {
            img: imgItems[locale][4],
            text: t('C_modal2_text5'),
        },
    ];

    const handleClose = () => {
        setIsOpen(false);
        setTimeout(() => {
            callback();
        }, 1000);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsPC(window.innerWidth > 1024);
        }
    }, []);

    useEffect(() => {
        setIsOpen(type === 2);
    }, [type]);

    return (
        <div className={`modal ${css.modal} ${open ? 'open' : 'close'}`}>
            <div className="content">
                <svg className="close" onClick={handleClose} xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                    <g clipPath="url(#clip0_1297_95200)">
                        <path
                            d="M28 49C39.598 49 49 39.598 49 28C49 16.402 39.598 7 28 7C16.402 7 7 16.402 7 28C7 39.598 16.402 49 28 49Z"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M28 49C39.598 49 49 39.598 49 28C49 16.402 39.598 7 28 7C16.402 7 7 16.402 7 28C7 39.598 16.402 49 28 49Z"
                            stroke="#ccc"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M35 21L21 35" stroke="#ccc" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M21 21L35 35" stroke="#ccc" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1297_95200">
                            <rect width="56" height="56" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <div className="info">
                    <p className="title">{t('C_modal2_title')}</p>
                    <p className="desc">{t('C_modal2_desc')}</p>
                </div>
                <Swiper
                    className="items"
                    modules={[Pagination, Navigation]}
                    navigation={!isPC}
                    pagination={!isPC}
                    loop={!isPC}
                    spaceBetween={isPC ? 24 : 0}
                    centeredSlides={!isPC}
                    slidesPerView={'auto'}
                    initialSlide={isPC ? 0 : items?.length - 1}
                >
                    {items?.map((item: ItemType, k: number) => (
                        <SwiperSlide className="item" key={k}>
                            <div className="item-img">
                                <EfImg pc={item.img} />
                            </div>
                            <p className="item-text">{item.text}</p>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
